import { WbHeaderNavigation, WbHeaderNavigationItem } from '@workbench/react';
import { useUserDataContext } from './client/userMenu/UserDataContext';
import { Routes } from '../routes/routes';
import { useNavigation } from '../utils/customHooks';
import { useTranslation } from '../common/i18n/useTranslation';
import { validationUtils } from '../utils/validationFunctions';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
    appBar: {
        display: 'flex',
    },
}));
function MBAppBarUserNavigation() {
    const { engineOilTests } = useUserDataContext();
    const navigateTo = useNavigation();
    const translate = useTranslation();

    const { classes } = useStyles();
    return (
        <WbHeaderNavigation aria-label="Main Navigation" className={classes.appBar}>
            <WbHeaderNavigationItem onClick={() => navigateTo(Routes.product)}>
                {translate('released_products')}
            </WbHeaderNavigationItem>
            <WbHeaderNavigationItem onClick={() => navigateTo(Routes.service)}>
                {translate('service')}
            </WbHeaderNavigationItem>
            {!validationUtils.isArrayEmpty(engineOilTests) && (
                <WbHeaderNavigationItem onClick={() => navigateTo(Routes.oil_test_engines)}>
                    {translate('my_oil_test_engines')}
                </WbHeaderNavigationItem>
            )}
        </WbHeaderNavigation>
    );
}

export default MBAppBarUserNavigation;
